import _bindInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/bind';
import classNames from 'classnames/bind';
import React from 'react';
import '@babel/runtime-corejs3/helpers/defineProperty';
import '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import '@babel/runtime-corejs3/core-js-stable/instance/fill';
import '@babel/runtime-corejs3/core-js-stable/object/keys';
import '@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols';
import '@babel/runtime-corejs3/core-js-stable/instance/filter';
import '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor';
import '@babel/runtime-corejs3/core-js-stable/instance/for-each';
import '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors';
import '@babel/runtime-corejs3/core-js-stable/object/define-properties';
import '@babel/runtime-corejs3/core-js-stable/object/define-property';
import IcInfo from '../icons/IcInfo.js';
import IcQMark from '../icons/IcQMark.js';
import styles from './CommonHeaderTitle.module.scss.js';

var cx = _bindInstanceProperty(classNames).call(classNames, styles);
function CommonHeaderTitle(_ref) {
  var title = _ref.title,
    tooltipIconType = _ref.tooltipIconType,
    onClickTooltip = _ref.onClickTooltip;
  var Icon = tooltipIconType && {
    question: IcQMark,
    exclamation: IcInfo
  }[tooltipIconType];
  return /*#__PURE__*/React.createElement("h2", {
    className: cx('title', {
      'has-tooltip': Icon
    })
  }, title, Icon && ( /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: cx('button-tooltip'),
    onClick: onClickTooltip
  }, /*#__PURE__*/React.createElement(Icon, {
    width: 16,
    height: 16,
    fill: "#767678"
  }), /*#__PURE__*/React.createElement("span", {
    className: "blind"
  }, "\uD234\uD301 \uBCF4\uAE30"))));
}

export { CommonHeaderTitle as default };
